import { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import './StudentMonthAttendanceContent.css'

const StudentMonthAttendanceContent = ({ attendanceData }) => {
  const attendanceSummary = attendanceData?.data || {};
  const attendanceList = attendanceSummary?.attendance_data || [];

  return (
    <>
  

<div className="attendance-cards">
  <div className="attendance-card total-card">
    <p className="card-title">Total Classes</p>
    <p className="card-value">{attendanceSummary.sum_of_all ?? 0}</p>
  </div>
  <div className="attendance-card">
    <p className="card-title">Absent</p>
    <p className="card-value text-red">{attendanceSummary.absent ?? 0}</p>
  </div>
  <div className="attendance-card">
    <p className="card-title">Present</p>
    <p className="card-value text-green">{attendanceSummary.present ?? 0}</p>
  </div>
  <div className="attendance-card">
    <p className="card-title">Partially Present</p>
    <p className="card-value text-yellow">{attendanceSummary.partial_present ?? 0}</p>
  </div>
</div>

<h2 className="attendance-heading">Attendance details</h2>

<div className="attendance-table">
  <div className="attendance-header">
    <span>Dates</span>
    <span>Time Spent / Total Class Time</span>
    <span>Polls Submitted / Total Polls</span>
    <span>Status</span>
  </div>

  {attendanceList.length > 0 ? (
    attendanceList.map((item, index) => (
      <div className="attendance-row" key={index}>
        <span>{item.meetdate ?? "-"}</span>
        <span>
          {item.time_spent ?? "-"} / {item.total_spent ?? "-"}
        </span>
        <span>{item.max_poll_attempted ?? 0}</span>
        <span>{item.attendance_status ?? "-"}</span>
      </div>
    ))
  ) : (
    <div className="no-data">No attendance data available</div>
  )}
</div>
    </>
  );
};

export default StudentMonthAttendanceContent;
